import Carousel from './carousel';

export { Carousel };
